<!--  -->
<template>
  <div class='about'>
    <img src="../assets/img/about-banner.png" width="100%" alt="">
     <Modular obj="About" name="modular1"></Modular>
     <div class="bg">
        {{text}}
     </div>
     <Modular obj="About" name="modular3"></Modular>
     <img class="aboutimg" src="../assets/img/about-img4.png" alt="">
    <Modular obj="About" name="modular4"></Modular>
  </div>
</template>
<script>
import Modular from '../components/Modular'
import Text from '../utils/text'
export default {
  name:'',
  components: {
    Modular
  },
  props:{},
  data() {
    return {
      text:''
    };
  },
  computed: {},
  watch: {},
  created() {
    this.text = Text.websiteText["About"].modular2.text
  },
  mounted() {

  },
  //方法集合
  methods: {

  },
}
</script>
<style lang='scss'>
  //@import url(); 引入公共css类
  .bg{
    margin:0 auto;
    width:700px;
    height:800px;
    background:url('../assets/img/about-img2.png') no-repeat;
    background-size:contain;
    font-size:24px;
    color:#fff;
    padding:35px 40px;
    box-sizing: border-box;
    line-height:48px;
    text-indent: 50px;
  }
  .aboutimg{
    display:block;
    margin:0 auto;
    width:700px;
  }
</style>